import { type ClientError } from 'graphql-request';
import { createContext, useContext } from 'react';

import type { AuthMutationVariables, MeQuery } from '@/graphql';

export interface AnonymousGuardContextType {
  currentUser?: MeQuery['me'];
  authenticate: (data: Omit<AuthMutationVariables, 'recaptchaToken'>) => void;
  authenticateResult: {
    isLoading: boolean;
    isError: boolean;
    error: ClientError | null;
  };
}

export const AnonymousGuardContext = createContext<AnonymousGuardContextType | null>(null);
export const useAnonymousGuardContext = (): AnonymousGuardContextType =>
  useContext(AnonymousGuardContext) as AnonymousGuardContextType;
